import Chip, { ChipProps } from "@mui/material/Chip";
import React from "react";

interface FdChipProps extends ChipProps {
    label?: string;
}

const FdChip = ({
  label,
  ...others
}: FdChipProps): JSX.Element => {
  return (
    <Chip aria-label="fd-chip" label={label} {...others} />    
  );
};

export default FdChip;
